import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FacilitiesRemote } from "../../infrastructure/facilities.remote";
import {
  FacilityQueryResult,
  CreateFacilityData,
  FacilityDetailsData,
  FacilityEditData,
  FacilityQueryParams
} from "../models/facility.model";

@Injectable({
  providedIn: "root",
})
export class FacilitiesFacade {
  constructor(private readonly remote: FacilitiesRemote) {}

  getFacilities(
    params: FacilityQueryParams,
  ): Observable<FacilityQueryResult> {
    return this.remote.query(params);
  }

  getFacilityById(id: number): Observable<FacilityDetailsData> {
    return this.remote.get(id);
  }

  createFacility(
    request: CreateFacilityData
  ): Observable<FacilityDetailsData> {
    return this.remote.create({ ...request });
  }

  removeFacility(id: number): Observable<void> {
    return this.remote.delete(id);
  }

  updateFacility(
    id: number,
    facilityData: FacilityEditData
  ): Observable<FacilityEditData> {
    return this.remote.patch(id, facilityData);
  }
}
